import ModalDialog from './modal-dialog';

function initPaymentDrawerToggle() {
  const drawerToggles = document.querySelectorAll('[data-toggle-payment-drawer]');
  const paymentModalEm = document.querySelector('#modal-product-afterpay');

  if (!drawerToggles || !paymentModalEm) return;

  // eslint-disable-next-line no-unused-vars
  const paymentFormModal = new ModalDialog(paymentModalEm, {
    triggerEl: drawerToggles,
    modalId: 'product-afterpay',
  });
}

export default initPaymentDrawerToggle;
